import * as React from "react";
import type { SVGProps } from "react";

const SvgEtfIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15}
        height={15}
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill="currentColor"
            d="M24 8v16H0V8ZM8.392 10H2v12h6.394a7 7 0 0 1 0-12ZM22 10h-6.392a7 7 0 0 1 0 12H22Zm-10 1a5 5 0 1 0 5 5 5 5 0 0 0-5-5Zm.277 1.75a1.773 1.773 0 0 1 1.9 1.885v.25h-1.43v-.25a.606.606 0 0 0-.132-.429.478.478 0 0 0-.373-.134.379.379 0 0 0-.332.163.876.876 0 0 0-.147.53l.026.743h1.189v1.309h-1.144l.017.466a2.078 2.078 0 0 1-.094.645h2.493l-.006 1.322h-4.48v-1.322h.25l.251.007s.026-.025.055-.1a1.546 1.546 0 0 0 .067-.5l-.018-.511h-.62v-1.316h.58l-.023-.734a2 2 0 0 1 .547-1.474 1.928 1.928 0 0 1 1.424-.55ZM23 4v2H1V4Zm-2-4v2H2V0Z"
        />
    </svg>
);
export default SvgEtfIcon;
